<template>
  <FormulateForm
    v-show="currentStep === name"
    v-model="getModel[name]"
    :name="name"
    class="wizard-step inner-form"
    @submit="submitStep()"
  >
    <slot />

    <div
      v-if="errorSubmitting"
      class="pt-3 text-primary-bravo text-right"
    >
      {{ i18n.form.errors.sendingRequest }}
    </div>

    <fieldset
      class="formulate-buttons flex my-2 py-6 border-t-2 justify-between items-center flex-wrap gap-2"
    >
      <FormulateInput
        v-show="
          typeof i18n.form.buttons !== 'undefined' &&
            typeof i18n.form.buttons.previous !== 'undefined'
        "
        type="button"
        :disabled="isSubmitting"
        @click="goToPreviousStep()"
      >
        <arrow-left-white class="icon" />
        {{ i18n.form.buttons.previous }}
      </FormulateInput>

      <FormulateInput
        v-if="
          typeof i18n.form.buttons !== 'undefined' &&
            typeof i18n.form.buttons.submit !== 'undefined' &&
            hideButton !== 'no'
        "
        type="submit"
        :disabled="isSubmitting"
        class="relative"
      >
        <span
          class="flex items-center"
        >
          {{ submitButtonText || i18n.form.buttons.send }}
          <arrow-right-white
            v-if="!isSubmitting"
            class="icon"
          />
          <div
            v-if="isSubmitting"
            class="relative has-size-sm ml-4"
            :class="classes"
          >
            <div class="loader-spinner" />
          </div>
        </span>
      </FormulateInput>
    </fieldset>
  </FormulateForm>
</template>

<script>
export default {
  name: 'WizardStep',
  components: {
    ArrowLeftWhite: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ArrowLeftWhite.vue'),
    ArrowRightWhite: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ArrowRightWhite.vue'),
  },
  props: {
    i18n: {
      type: Object,
      default: () => {},
    },
    name: {
      type: String,
      default: () => '',
    },
    model: {
      type: Object,
      default: () => {},
    },
    nextStep: {
      type: [Function, String],
      default: () => '',
    },
    previousStep: {
      type: String,
      default: () => '',
    },
    submitButtonText: {
      type: String,
      default: () => '',
    },
    isSubmitting: {
      type: Boolean,
      default: () => false,
    },
    errorSubmitting: {
      type: Boolean,
      default: () => false,
    },
    gtm: {
      type: Function,
      default: () => {},
    },
    hideButton: {
      type: String,
      default: 'yes',
    },
  },
  computed: {
    currentStep() {
      return this.$parent.currentStep;
    },
    getModel() {
      return this.model
    }
  },
  methods: {
    submitStep() {
      if (typeof this.nextStep === 'function') {
        const returnValue = this.nextStep();
        if (typeof returnValue === 'string') {
          this.$parent.goToStep(returnValue);
        }
      } else {
        const stepName =
          this.name === 'myChild' ? 'registration_child_data' : 'registration_personal_data';
        this.gtm(stepName);
        this.$parent.goToStep(this.nextStep);
      }
    },
    goToPreviousStep() {
      if (this.previousStep) {
        this.$parent.goToStep(this.previousStep);
      } else {
        window.history.go(-1);
      }
    },
  },
};
</script>

<style lang="postcss">
.wizard-step {
  & > h1,
  & > h2 {
    @apply text-3xl font-medium;
  }

  .loader-spinner {
    border-radius: 50%;
    border-width: 2.5px;
    --tw-border-opacity: 1;
    border-color: rgba(255, 255, 255, var(--tw-border-opacity));
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-name: rotate-forever;
    animation-timing-function: linear;
    height: 16px;
    width: 16px;
    border-right-color: transparent;
  }
}
</style>
